// Utility functions for NNM CRM

// VT (Valeur Temps) = 5 minutes
export const VT_TO_MIN = 5;

export const vtToMin = (vt) => Math.round(vt * VT_TO_MIN);

export const minToHM = (min) => {
  const h = Math.floor(min / 60);
  const m = min % 60;
  return `${h}h${m.toString().padStart(2, '0')}`;
};

export const vtToHM = (vt) => minToHM(vtToMin(vt));

export const fmtDate = (d) => {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('fr-CH', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

export const fmtDateShort = (d) => {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('fr-CH', {
    day: '2-digit',
    month: 'short',
  });
};

export const fmtCHF = (n) => {
  if (n === null || n === undefined) return '—';
  return `CHF ${Number(n).toLocaleString('fr-CH')}.-`;
};

// OT Statuts
export const OT_STATUTS = {
  provisoire: { label: 'Provisoire', cls: 'badge-yellow' },
  confirme: { label: 'Confirmé', cls: 'badge-green' },
  en_cours: { label: 'En cours', cls: 'badge-blue' },
  termine: { label: 'Terminé', cls: 'badge-gray' },
  annule: { label: 'Annulé', cls: 'badge-red' },
};

// Pipeline Stages
export const PIPELINE_STAGES = [
  { key: 'premier_contact', label: '1er Contact', color: '#4a5568' },
  { key: 'qualification', label: 'Qualification', color: '#744210' },
  { key: 'offre_envoyee', label: 'Offre envoyée', color: '#c05621' },
  { key: 'negociation', label: 'Négociation', color: '#dd6b20' },
  { key: 'gagne', label: 'Gagné', color: '#22c55e' },
  { key: 'perdu', label: 'Perdu', color: '#ef4444' },
];

// Days of week (French)
export const JOURS_SEMAINE = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'];
export const JOURS_COURTS = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven'];

// Months (French)
export const MOIS_FR = [
  'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
  'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre',
];

// Get week number
export const getWeekNumber = (dateStr) => {
  const d = new Date(dateStr);
  const start = new Date(d.getFullYear(), 0, 1);
  return Math.ceil(((d - start) / 86400000 + start.getDay() + 1) / 7);
};

// Get week dates (Mon-Fri)
export const getWeekDates = (dateStr) => {
  const d = new Date(dateStr);
  while (d.getDay() !== 1) d.setDate(d.getDate() - 1); // Find Monday
  return Array.from({ length: 5 }, (_, i) => {
    const dd = new Date(d);
    dd.setDate(d.getDate() + i);
    return dd.toISOString().split('T')[0];
  });
};

// Get month weeks (for calendar view)
export const getMonthWeeks = (year, month) => {
  const weeks = [];
  const d = new Date(year, month, 1);
  
  // Find first Monday
  while (d.getDay() !== 1) d.setDate(d.getDate() - 1);
  
  while (d.getMonth() <= month || weeks.length === 0) {
    const week = [];
    for (let i = 0; i < 5; i++) {
      const dd = new Date(d);
      week.push(dd.toISOString().split('T')[0]);
      d.setDate(d.getDate() + 1);
    }
    d.setDate(d.getDate() + 2); // Skip weekend
    weeks.push(week);
    if (d.getMonth() > month && weeks.length >= 4) break;
  }
  return weeks;
};

// Charge color based on percentage
export const chargeColor = (pct) => {
  if (pct === 0) return 'transparent';
  if (pct <= 40) return 'rgba(34, 197, 94, 0.4)';
  if (pct <= 70) return 'rgba(34, 197, 94, 0.6)';
  if (pct <= 90) return 'rgba(234, 179, 8, 0.6)';
  return 'rgba(239, 68, 68, 0.6)';
};

export const chargeTextColor = (pct) => {
  if (pct === 0) return 'var(--text3)';
  if (pct <= 70) return 'var(--green)';
  if (pct <= 90) return 'var(--yellow)';
  return 'var(--red)';
};

// Type absence
export const TYPE_ABSENCE = [
  { key: 'conge', label: 'Congé', icon: '🏖', color: '#3b82f6' },
  { key: 'maladie', label: 'Maladie', icon: '🤒', color: '#ef4444' },
  { key: 'formation', label: 'Formation', icon: '📚', color: '#8b5cf6' },
  { key: 'autre', label: 'Autre', icon: '📋', color: '#6b7280' },
];
